import { Heading } from 'component-library/components/typography/Heading';
import { Screen, ShowOn } from 'component-library/components/wrappers/ShowOn';
import { colors } from 'component-library/styles/colors';
import React, { FC } from 'react';
import styled from 'styled-components';

import { FeaturesSectionProps } from '.';
import { Alignment, FeatureSection } from './FeatureSection';
import { SECTIONS } from './utils';

const Text = styled.div`
  padding: 0 20px 40px;
`;

export const FeaturesSectionSmall: FC<FeaturesSectionProps> = ({
  heading,
  topSection,
  sections,
}) => (
  <ShowOn screens={[Screen.Sm, Screen.Md]}>
    <Text>
      <Heading variant={4}>{heading}</Heading>
    </Text>
    {topSection && (
      <FeatureSection
        {...topSection}
        alignment={Alignment.Column}
        backgroundColor={colors.teal}
      />
    )}
    {sections.map((section, idx) => (
      <FeatureSection
        key={idx}
        {...section}
        backgroundColor={SECTIONS[(idx + 1) as 1 | 2 | 3]}
        alignment={Alignment.Column}
      />
    ))}
  </ShowOn>
);
